/**
 * Single source of truth for contact-related constants (e.g. company types).
 * Used by Contacts filter, edit form, and table display.
 */
export const COMPANY_TYPE_OPTIONS = [
    { value: "shopping_centre", label: "Landlord / Centre Management" },
    { value: "retail_owner", label: "Retail Tenant / Brand" },
    { value: "fit_out_contractor", label: "Contractor / Trade Partner" },
    { value: "tenancy_delivery_manager", label: "Tenancy Delivery Manager" },
    { value: "project_manager", label: "Project Manager / Consultant" },
    { value: "other", label: "Other" },
];
/** All company type values for filter dropdown and validation */
export const COMPANY_TYPE_VALUES = COMPANY_TYPE_OPTIONS.map((o) => o.value);
/** Map company type key to display label */
export function mapCompanyTypeKeyToLabel(key) {
    if (!key)
        return "";
    const option = COMPANY_TYPE_OPTIONS.find((opt) => opt.value === key);
    return option ? option.label : key;
}
/** Map display label to company type key */
export function mapCompanyTypeLabelToKey(label) {
    if (!label)
        return "";
    const option = COMPANY_TYPE_OPTIONS.find((opt) => opt.label === label);
    return option ? option.value : label;
}
export const TIER_OPTIONS = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    // { value: "platinum", label: "Platinum" },
    // { value: "gold", label: "Gold" },
    // { value: "silver", label: "Silver" },
    // { value: "bronze", label: "Bronze" },
    { value: "-", label: "None" },
];
